module.exports = __webpack_public_path__ + "static/media/policeCar_black.f82cae3e.svg";